module.exports = __webpack_public_path__ + "static/media/favourite.7898ef03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Features/favourite.jpg
// module id = 639
// module chunks = 0